import { InjectionToken } from "@angular/core";
import { CommonLibraryEnvironment } from "./models";

/**
 * Injection token providing the library's environment configuration
 * (API URLs, Auth0 settings) to consumers of the vnext module.
 */
export const LIB_ENVIRONMENT = new InjectionToken<CommonLibraryEnvironment>(
  "LIB_ENVIRONMENT",
);
